export default function () {
  this.loadFavorites()
}
